$(document).ready ->
  window.page_order_sortable = () ->
    $(".pages-sortable").sortable
      start: (event,ui) ->
        pages_list = $(ui.item).parent()
        chapter_id = pages_list.attr('data-chapter-id')
      stop: (event, ui) ->
        new_page_sequence = []
        pages_list = $(ui.item).parent()
        chapter_id = pages_list.attr('data-chapter-id')

        page_current_index = $(ui.item).attr('data-page-index')
        page_new_index = null
        $(pages_list).children('li').each (index,page) ->
          page_new_index = index.toString() if $(page).attr('data-page-index') == page_current_index

        unless page_current_index == page_new_index

          $(pages_list).children('li').each (index,item) ->
            page_id = $(item).attr('data-page-id')
            new_page_sequence.push(page_id)
          $("#chapter-page-order-loader-#{chapter_id}").find("i").hide()
          $("#chapter-page-order-loader-#{chapter_id}").find("span").css("color","#666666")
          $("#chapter-page-order-loader-#{chapter_id}").find("span").text("Changing page order .....")
          $("#chapter-page-order-loader-#{chapter_id}").find("img").show()
          $("#chapter-page-order-loader-#{chapter_id}").show()
          $(pages_list).css "pointer-events","none"
          $.post("/chapters/#{chapter_id}/pages/assign_order.json?",{pages: new_page_sequence}).done(
            (success) ->
              current_page_sequence = success.sequence
              $("#chapter-page-sequence-#{chapter_id}").val(JSON.stringify(success.sequence))
              pages_list.children('li').each (index,item) ->
                $(item).attr('data-page-index',index)
                $(item).find('.page-index').text((index + 1).toString())
              $("#chapter-page-order-loader-#{chapter_id}").find("span").css("color","green")
              $("#chapter-page-order-loader-#{chapter_id}").find("span").text("Page order changed successfully")
              $("#chapter-page-order-loader-#{chapter_id}").find("i").css({"color":"green"})
              $("#chapter-page-order-loader-#{chapter_id}").find("img").hide()
              $("#chapter-page-order-loader-#{chapter_id}").find("i").addClass("fa-check")
              $("#chapter-page-order-loader-#{chapter_id}").find("i").show()
              $(pages_list).css "pointer-events","all"
              setTimeout ->
                $("#chapter-page-order-loader-#{chapter_id}").find("i").removeClass("fa-check")
                $("#chapter-page-order-loader-#{chapter_id}").find("span").text("")
                $("#chapter-page-order-loader-#{chapter_id}").hide()
              ,3000
          ).fail(
            (error) ->
              $("#chapter-page-order-loader-#{chapter_id}").find("span").css("color","red")
              if error.status == 422
                $("#chapter-page-order-loader-#{chapter_id}").find("span").text("There was an error changing page order: #{error.responseJSON.error}")
              else if error.status == 500
                $("#chapter-page-order-loader-#{chapter_id}").find("span").text("An exception was thrown on the server. Please try again later.")
              $("#chapter-page-order-loader-#{chapter_id}").find("i").css("color","red")
              $("#chapter-page-order-loader-#{chapter_id}").find("i").show()
              $("#chapter-page-order-loader-#{chapter_id}").find("img").hide()
              $("#chapter-page-order-loader-#{chapter_id}").find("i").addClass("fa-times")
              $(pages_list).css "pointer-events","all"

              ## Reset page order

              moved_page_original_position = $(ui.item).attr('data-page-index')
              original_page = $($(ui.item).parent().children()[moved_page_original_position])
              original_page_clone = $(original_page).clone true
              $(original_page).replaceWith($(ui.item).clone true)
              $(ui.item).replaceWith(original_page_clone)

              setTimeout ->
                $("#chapter-page-order-loader-#{chapter_id}").find("i").removeClass("fa-times")
                $("#chapter-page-order-loader-#{chapter_id}").find("span").text("")
                $("#chapter-page-order-loader-#{chapter_id}").hide()
              ,3000
          )
  window.page_order_sortable()
